import api from './api';

export interface JiraConfig {
  url: string | null;
  email: string | null;
  api_token: string | null;
  project_key: string | null;
}

export interface ServiceNowConfig {
  instance: string | null;
  user: string | null;
  password: string | null;
  table: string | null;
}

export interface ItsmConfig {
  jira: JiraConfig;
  servicenow: ServiceNowConfig;
  jira_configured: boolean;
  servicenow_configured: boolean;
}

export async function getItsmConfig(): Promise<ItsmConfig> {
  const res = await api.get('/api/v1/settings/integrations');
  return res.data;
}

export async function saveItsmConfig(body: {
  jira?: Partial<JiraConfig>;
  servicenow?: Partial<ServiceNowConfig>;
}): Promise<ItsmConfig> {
  const res = await api.put('/api/v1/settings/integrations', body);
  return res.data;
}

/** Issue a short-lived Flower access token. */
export async function getFlowerToken(): Promise<string> {
  const res = await api.post('/api/v1/admin/flower/token');
  return res.data.token as string;
}
